module.exports = __webpack_public_path__ + "media/images/admin/icons/align-left-48db7460b1ffe840e7be5e286b541c65.svg";